module.exports = __webpack_public_path__ + "img/jquery-logo.9999c1a8.gif";